module.exports = __webpack_public_path__ + "img/Dragon.93d9b3a4.svg";